import AuthStore from '../../stores/AuthStore';
import { TrackHookConfig } from './trackerConfig';
import { Tracker } from './trackerInterface';

export const useTracker = (
    auth: Pick<AuthStore, 'reportEvent'>,
    _config: Partial<TrackHookConfig> = {}
): Tracker => {
    return {
        track(event, payload) {
            if (!auth) {
                // TODO move tracking logic out of auth store
                // currently the interviewer supported session-based auth that
                // is not integrated with the old legacy auth store
                console.error('No auth found, tracking not available');
                return;
            }
            auth.reportEvent(event, payload);
        },
    };
};
